import styled from '@emotion/native';
import { PADDING } from 'design-system/theme';

export const PaddedWrapper = styled.View({
  paddingHorizontal: PADDING.s,
  marginVertical: PADDING['3xs'],
});
